import React, { createContext, useCallback, useContext, useRef } from 'react';

import type { OngletConversations } from '../../api/useConversations';

/**
 * Ce que la liste retrouve en revenant d'un fil — audit 2026-09-23.
 *
 * En mémoire, jamais sur disque. Tenu par établissement ET dossier : un autre hôtel
 * n'hérite jamais de l'onglet ni de la position d'un autre (#25). Les pages déjà
 * chargées ne sont PAS restaurées : figées, elles recréeraient les doublons que
 * `ListeConversations.actualiser` évite. On revient en page 1, au même endroit.
 */
export interface EtatListe {
    onglet: OngletConversations;
    defilement: number;
    /** Le terme de recherche — vide par défaut. Voir `RechercheConversations`. */
    recherche: string;
}

const ETAT_INITIAL: EtatListe = { onglet: 'tous', defilement: 0, recherche: '' };
const Ctx = createContext<React.MutableRefObject<Map<string, EtatListe>> | null>(null);

export function EtatListeProvider({ children }: { children: React.ReactNode }) {
    const memoire = useRef(new Map<string, EtatListe>());
    return <Ctx.Provider value={memoire}>{children}</Ctx.Provider>;
}

export function useEtatListe(dossier: 'inbox' | 'closed', facilityId: number | null) {
    const memoire = useContext(Ctx);
    const cle = `${facilityId ?? 'aucun'}:${dossier}`;
    const etat = memoire?.current.get(cle) ?? ETAT_INITIAL;

    const enregistrer = useCallback(
        (e: EtatListe) => {
            memoire?.current.set(cle, e);
        },
        [memoire, cle],
    );

    return { etat, enregistrer };
}
